import { render } from "./TicketOverview.vue?vue&type=template&id=94941a2c"
import script from "./TicketOverview.vue?vue&type=script&lang=js"
export * from "./TicketOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__